export default __webpack_public_path__ + "static/media/accommodations3_668.cba73e97.webp";